import { Pipe, PipeTransform } from "@angular/core";
import { RecurrenceDays } from "../../shared/services/request.service";

@Pipe({ name: "recurrenceDayNames" })
export class RecurrenceDayNamesPipe implements PipeTransform {
  transform(value: RecurrenceDays) {
    let days: string[] = [];

    if (value === undefined || value === null) {
      return "";
    } else {
        if (value & RecurrenceDays.Monday) 
            days.push('Monday');
        if (value & RecurrenceDays.Tuesday) 
            days.push('Tuesday');
        if (value & RecurrenceDays.Wednesday) 
            days.push('Wednesday');
        if (value & RecurrenceDays.Thursday) 
            days.push('Thursday');
        if (value & RecurrenceDays.Friday) 
            days.push('Friday');

        return days.join(', ');
    }
  }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/pipes/recurrence-days.pipe.ts